export default "__VITE_ASSET__iubrTyIm__"